import React from 'react'

const About = () => {
  return (
    <div className="About-container">
      <img
        src={require('../assets/amanda.png')}
        className="About-image"
        alt="profile-photo"/>
      <div className="text">
        Hi there, thanks for checking out my site. I'm an LA based full stack software engineer working remotely with the best four legged coworkers around: my pups Ein & Gohan.
        <br></br>
        When I'm not thinking about what to build next, there's a 99.9% chance I'm thinking about where I'm going to eat next!
      </div>
    </div>
  )
}

export default About



// WEBPACK FOOTER //
// ./src/components/About.js